/** Profile link for CTAs and empty grid cells. Feed tiles come from GET /instagram-feed. */
export const INSTAGRAM_PROFILE_URL =
  "https://www.instagram.com/inclusiviteee/";

export type InstagramFeedItem = {
  src: string;
  href: string;
};
